module.exports = __webpack_public_path__ + "assets/images/open.9e664494b89796f6af5591761a70cc80.png";